import { formatUsd, formatPlanDate, formatQuarterLabel } from '../installmentFormat'
import { cardLast4 } from '../../../../components/CreditCardInput/creditCard'

function paymentMethodLast4 (method = {}) {
  if (method.last4) return String(method.last4)
  if (method.mode === 'card' || method.methodType === 'card') return cardLast4(method.ccnumber)
  const accountDigits = String(method.accountNumber || '').replace(/\D/g, '')
  return accountDigits.length >= 4 ? accountDigits.slice(-4) : ''
}

export default function ReviewStep ({ invoice, method, frequency, installmentCount, startDate, schedule }) {
  const last4 = paymentMethodLast4(method)
  const methodLine = method?.methodType === 'card' || method?.mode === 'card'
    ? `Credit card ending in ${last4 || '••••'} (instant)`
    : `Bank account ending in ${last4 || '••••'}`

  return (
    <div className='flex flex-col gap-4'>
      <p className='text-sm text-slate-600 dark:text-slate-300'>Confirm your payment plan. The first charge runs on the start date you chose.</p>
      <div className='rounded-2xl border border-gray-200 dark:border-slate-700 p-4 flex flex-col gap-2 text-sm'>
        <Row label='Invoice' value={`#${invoice?.invoiceNumber || '—'} · ${formatQuarterLabel(invoice?.quarter)}`} />
        <Row label='Amount' value={formatUsd(invoice?.invoiceAmount)} />
        <Row label='Payment method' value={methodLine} />
        <Row label='Schedule' value={`${installmentCount} ${frequency} payments starting ${formatPlanDate(startDate)}`} />
      </div>
      <div className='rounded-2xl border border-gray-200 dark:border-slate-700 overflow-hidden'>
        {(schedule || []).map((row) => (
          <div key={row.sequence} className='flex justify-between px-4 py-3 border-b last:border-b-0 border-gray-100 dark:border-slate-700'>
            <span className='text-sm text-slate-600 dark:text-slate-300'>Payment {row.sequence} · {formatPlanDate(row.scheduledDate)}</span>
            <span className='text-sm font-semibold'>{formatUsd(row.amount)}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

function Row ({ label, value }) {
  return (
    <div className='flex justify-between gap-4'>
      <span className='text-slate-500'>{label}</span>
      <span className='font-semibold text-slate-900 dark:text-white text-right'>{value}</span>
    </div>
  )
}
